import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { PremiumFunctionType, usePremiumValidator } from "@/services/PremiumValidator";
import { observer } from "mobx-react-lite";
import React from "react";
import { Spin } from "antd";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";
import PageNoSelectCore from "./PageNoSelectCore";
import ShopDTO from "@/dto/shop/ShopDTO";

interface PageNoSelectProps {
    shop: ShopDTO;
    tab: OrderTab;
}

const PageNoSelect: React.FC<PageNoSelectProps> = function (props) {
    const { shop, tab } = props;
    const shopId = shop?.id;
    const orderManagementStore = useOrderManagementStore();
    const { pageSize } = orderManagementStore.table.pagination;
    const { validate: premiumValidate, loading: premiumValidateLoading } = usePremiumValidator();

    const handlePageSizeChange = async (value: number) => {
        const shop = orderManagementStore.globalStore.shopMapping.get(shopId);
        const shopName = shop?.name;

        collectEvent(DataTrackEvent.CHANGE_ORDER_LIST_PAGE_SIZE, {
            shop_id: shopId,
            shop_name: shopName,
            page_size: value,
        });

        if (value > 500) {
            const flag = await premiumValidate({
                type: PremiumFunctionType.ORDER_LIST_ORDER_NUMBER_1000,
                shopId: shopId,
            });
            if (!flag) return;
        }

        orderManagementStore.table.changePageNo(1);
        orderManagementStore.table.changePageSize(shopId, value);
        orderManagementStore.fetchOrders(shopId, tab);
    };

    return (
        <span className="pr">
            <Spin spinning={premiumValidateLoading}>
                <PageNoSelectCore pageSize={pageSize} onPageSizeChange={handlePageSizeChange} shop={shop} />
            </Spin>
        </span>
    );
};

export default observer(PageNoSelect);
